module.exports = __webpack_public_path__ + "static/media/speakers_logos_Pacific.a4ec4c18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Pacific.jpg
// module id = 275
// module chunks = 0